import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/site.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/payment.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/page.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/footer.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/header.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/project-detail.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/projects.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/donate.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/about.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/contact.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/impact.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/volunteer.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/qris.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/SessionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/contexts/LanguageContext.tsx");
